<template>
  <el-dialog
    title="请按照要求支付"
    :visible="visible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
    top="7vh"
  >
    <el-image style="width: 400px; height: 400px" :src="resolveImg(qrUrl)"></el-image>
    <div>
      <i class="el-icon-warning" />
      此收款方式不能关联订单支付状态，需要人工审核，缴费请备注<strong>姓名和身份证号</strong>，以便人工查询！
    </div>
  </el-dialog>
</template>

<script>
import { getQrPicture } from '../api/registrationQuery'
import { resolveImg } from '@/utils/imgFill'
export default {
  name: 'PayQrDialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    qrUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    resolveImg,
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.el-icon-warning {
  color: yellow;
  margin-right: 2px;
}
</style>
